import {
  dataBindingOverrideRules,
  CustomManifestAction,
  NativeActionType,
} from '@wix/cms-platform-integration';

export type DataBindingConfigQuery = {
  componentType: string;
  role?: string;
};

export type DataBindingOverrideConfig = {
  actions: Record<string, CustomManifestAction>;
  hiddenActions: NativeActionType[];
};

export function getDataBindingOverrideConfig(
  query: DataBindingConfigQuery,
): DataBindingOverrideConfig | null {
  const { actionsOverrideDefinition, hiddenActionsOverrideDefinition } =
    dataBindingOverrideRules;

  const matchingActionsRule = findMatchingRule(
    actionsOverrideDefinition,
    query,
  );
  const matchingHiddenRule = findMatchingRule(
    hiddenActionsOverrideDefinition,
    query,
  );

  if (!matchingActionsRule && !matchingHiddenRule) {
    return null;
  }

  return {
    actions: matchingActionsRule?.actions || {},
    hiddenActions: matchingHiddenRule?.hiddenActions || [],
  };
}

function findMatchingRule<T extends { componentType: string; role?: string }>(
  rules: T[],
  query: DataBindingConfigQuery,
): T | undefined {
  return rules.find((rule) => {
    return isComponentTypeMatch(rule, query) && isRoleMatch(rule, query);
  });
}

function isComponentTypeMatch(
  rule: { componentType: string },
  query: DataBindingConfigQuery,
): boolean {
  return rule.componentType === query.componentType;
}

function isRoleMatch(
  rule: { role?: string },
  query: DataBindingConfigQuery,
): boolean {
  return query.role !== undefined ? rule.role === query.role : !rule.role;
}
